/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ifAuthenticated } from '../routeValidation';
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

// Documents
const Tickets = () =>
  import(
    /* webpackChunkName: "Tickets" */ '@/views/tickets/ticket.vue'
  );

const permissionsPages = {
  path: '/',
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  name: 'tickets',
  children: [
    {
      path: '/tickets',
      component: Tickets,
      meta: {
        navbarType: 'light',
      },
    }
  ],
};

export default permissionsPages;
